import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { MobileNav } from '../components/MobileNav';
import { Sparkles, Star, Quote, ArrowRight } from 'lucide-react';
import { Footer } from '../components/Footer';
import SEO, { pageSEO } from '../components/SEO';

// Twinkling Stars Component
const TwinklingStars = () => (
  <div className="floating-stars">
    {[...Array(12)].map((_, i) => (
      <div key={i} className="floating-star">
        <Star className="w-full h-full fill-current" />
      </div>
    ))}
  </div>
);

const testimonials = [
  {
    name: "Nanette Bergerac Koomen",
    date: "December 2023",
    rating: 5,
    text: "Karine is nothing short of astounding! She predicted my meeting my husband years before I actually did and where and when I'd meet him and what he looked like (and I lived in another state!) She also predicted each of my daughter's three children before my daughter had any idea she was expecting any of them. After the loss of a pregnancy Karine predicted a girl would be born to my daughter shortly thereafter and what she would look like and it turned out to be spot on. She has read for me numerous times and never fails to leave me in awe. She gives details that are surprising and unexpected. Please reach out to Karine!",
    initials: "NK"
  },
  {
    name: "LaRaysha Reese",
    date: "September 2024",
    rating: 5,
    text: "My first of many sessions to come with Karine and I can say that she is not only delightful but so genuine and caring! With life and changes I can truly say that Karine was sent to me. You can tell she is passionate about what she does and educates you along the way, which I am so grateful for. I love what is in store for me and the path/journey I will create with her guidance along the way.",
    initials: "LR"
  },
  {
    name: "Monica Clark Darlage",
    date: "July 2024",
    rating: 5,
    text: "Karine is amazing! She went beyond to give me finally a sense of relief. Told me things only my husband I knew. I highly recommend Karine to help you to be able to answer unanswered questions and give you a sense of relief. You will not be sorry! Thank Karine for your time and energy. You touched my heart in more ways then you know. I cannot wait to be reconnected with my husband again. You are a very amazing, passionate person with a God given talent.",
    initials: "MC"
  },
  {
    name: "Peggy Janes Sanders",
    date: "July 2024",
    rating: 5,
    text: "I just got finished talking with Karine and oh my god she is so amazing. I had 4-5 people come through and I learned lots of stuff about numerology. Things make a lot more sense now. I would recommend her highly!",
    initials: "PJ"
  },
  {
    name: "Cindy Emminger",
    date: "January 2024",
    rating: 5,
    text: "I'm still in awe of my talk with Karine! She has given me a little hope first time in 2 months that Marc is here with me everywhere I go! She is very passionate and gifted and enjoys her job. I'm so glad Marc was comfortable enough with her to tell me all the things he did! I didn't want to end our meeting. She truly feels my pain and his love for me and has promised to help me through this new journey. This gives me hope!",
    initials: "CE"
  },
  {
    name: "Earl Thompson",
    date: "December 2023",
    rating: 5,
    text: "Karine is amazing. She has helped me and several of my friends connect with deceased loved ones. Karine is so gifted. She is a gift that came into my life.",
    initials: "ET"
  },
  {
    name: "Scott Howard McDaniel",
    date: "December 2023",
    rating: 5,
    text: "The past 10 years of my life without a questionable doubt have been the most trying and difficult times of my life. Divorced, betrayed, lost business, started over twice at 59... I had never met Karine or even spoken with her until today. I answered the phone with a very heavy spirit and not in a good place. I never ever felt rushed, hurried, only the calming voice that guided me down a road of remembrance and reflection. Karine's insightful spirit and ability to lead you out of darkness and help you understand why things occur and help you find a pathway to your destination was beautiful. This was my first time ever having a reading and understanding numerology. It opened my eyes to a new chapter in my life!",
    initials: "SM"
  },
  {
    name: "Rose Lummert",
    date: "December 2023",
    rating: 5,
    text: "Karine Bergerac Burt is an amazing person whose kindness and genuine care for people shines through. Her ability to tap in is off the charts. I have to say she is absolutely spot on with the information she has given me and it has helped me better understand myself and things surrounding me. Thanks Karine, you are the real deal.",
    initials: "RL"
  },
  {
    name: "Araceli Barajas Back",
    date: "December 2023",
    rating: 5,
    text: "I had the privilege of meeting Karine through a recommendation from another friend and it was life changing. Karine educated me to the world of numerology and intuition almost 2 years ago when I was experiencing some life changing circumstances. She was able to bring me to rest and explain things in a way that they made sense. Our conversations were rich and I never wanted them to end! Her knowledge of numerology and her willingness to teach was truly invaluable to me. She was able to predict several circumstances for me accurately as well as explain certain aspects of my personality and how they affect my circumstances.",
    initials: "AB"
  },
  {
    name: "Paige Brandie Dugger",
    date: "December 2023",
    rating: 5,
    text: "I met Karine in 2008. We lost touch for periods throughout the years. However, she has always been able to give me the right information exactly when it was needed. Her gift is God given and she doesn't abuse it or misuse it. She's an amazing spirit.",
    initials: "PD"
  },
  {
    name: "Bonnie Falk",
    date: "December 2023",
    rating: 5,
    text: "Karine Bergerac Burt has always been spot on whenever my daughter or I need her help. And just a great person with a great spirit.",
    initials: "BF"
  },
  {
    name: "Marie Slattery",
    date: "December 2023",
    rating: 5,
    text: "Enlightened. A gifted seer who combines both the ancient knowledge of numerology along with her gift of seeing to help humankind. I highly recommend her for those times you need insight or guidance on your journey. Karine has a gift and you won't be disappointed.",
    initials: "MS"
  }
];

const StarRating = ({ rating }) => (
  <div className="flex gap-1">
    {[...Array(5)].map((_, i) => (
      <Star
        key={i}
        className={`w-5 h-5 ${i < rating ? 'text-[#D4AF37] fill-[#D4AF37]' : 'text-gray-300'}`}
      />
    ))}
  </div>
);

export const TestimonialsPage = () => {
  return (
    <div className="min-h-screen swirl-bg relative">
      <SEO {...pageSEO.testimonials} />
      <TwinklingStars />
      <MobileNav />

      <main className="max-w-6xl mx-auto px-6 md:px-12 py-12">
        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-purple-500 via-amber-400 to-pink-500 mb-6 glow-purple">
            <Quote className="w-10 h-10 text-white" />
          </div>
          <h1 className="font-mystical text-4xl md:text-5xl lg:text-6xl text-[#2D1B3D] font-bold mb-4">
            What Clients Say
          </h1>
          <p className="text-[#4A3A5A] text-lg md:text-xl max-w-2xl mx-auto mb-6">
            Real stories from real people whose lives have been touched by Karine's gift
          </p>
          <div className="flex items-center justify-center gap-2">
            <StarRating rating={5} />
            <span className="text-[#2D1B3D] font-bold text-lg ml-2">5.0</span>
            <span className="text-[#6D5A7D]">({testimonials.length} reviews)</span>
          </div>
          <p className="text-[#8B5CF6] mt-4 text-lg">
            These testimonials and more can be found on{' '}
            <a 
              href="https://www.facebook.com/themystictellers" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#EC4899] hover:text-[#D4AF37] font-bold underline"
            >
              Facebook
            </a>
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="ethereal-card rounded-3xl p-8 relative"
              data-testid={`testimonial-card-${index}`}
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 -left-2 w-12 h-12 rounded-full bg-gradient-to-br from-[#8B5CF6] to-[#D4AF37] flex items-center justify-center shadow-lg">
                <Quote className="w-6 h-6 text-white" />
              </div>

              {/* Content */}
              <div className="pt-4">
                <StarRating rating={testimonial.rating} />
                
                <p className="text-[#3D2A4D] text-lg leading-relaxed mt-4 mb-6">
                  "{testimonial.text}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-4 pt-4 border-t border-purple-100">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#8B5CF6] to-[#EC4899] flex items-center justify-center text-white font-bold text-lg">
                    {testimonial.initials}
                  </div>
                  <div>
                    <p className="font-bold text-[#2D1B3D]">{testimonial.name}</p>
                    <p className="text-[#8C7A9C] text-sm">{testimonial.date}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5 }}
          className="ethereal-card rounded-3xl p-10 md:p-14 text-center"
        >
          <h2 className="font-mystical text-3xl md:text-4xl text-[#2D1B3D] font-bold mb-4">
            Ready to Transform Your Life?
          </h2>
          <p className="text-[#4A3A5A] text-lg mb-8 max-w-xl mx-auto">
            Join these amazing souls who have discovered clarity, healing, and their destined path through Karine's guidance.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contact" data-testid="cta-contact">
              <Button className="rounded-full btn-magic px-8 py-6 text-lg font-bold">
                Book Your Session
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
            <Link to="/calculator" data-testid="cta-calculator">
              <Button 
                variant="outline" 
                className="rounded-full px-8 py-6 text-lg font-bold border-2 border-[#8B5CF6] text-[#8B5CF6] hover:bg-[#8B5CF6]/10"
              >
                Try Soulmate Calculator
              </Button>
            </Link>
          </div>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
};

export default TestimonialsPage;
